
import card from '~/mixins/card'
export default {
    mixins: [card],
    // #721: the builder passes the exact plan; the legacy cards keep relying on
    // the mixin's first pdp/mapd.
    props: {
        plan: { type: Object, default: null },
    },
}
